
import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar"; // 🚗 vehicle icon
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1301,
    color: "#fff",
  },
  loaderComp: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  carIcon: {
    fontSize: 50,
    color: "#024a85ff",
    animation: "$carBounce 1.5s infinite ease-in-out",
    // background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  },
  text: {
    marginTop: theme.spacing(1),
    fontSize: "1.2rem",
    fontWeight: 500,
    letterSpacing: "1px",
  },
  "@keyframes carBounce": {
    "0%, 100%": { transform: "translateY(0)" },
    "50%": { transform: "translateY(-10px)" },
  },
}));

const LoadingComponent = ({ isLoading }) => {
  const classes = useStyles();

  return (
    <Backdrop
      className={classes.backdrop}
      open={Boolean(isLoading)}
      style={{ display: isLoading ? "" : "none" }}
    >
      <section className={classes.loaderComp}>
        <LocalShippingIcon className={classes.carIcon} />
        <CircularProgress color="secondary" />
        <div className={classes.text}>Loading Data...</div>
      </section>
    </Backdrop>
  );
};

export default LoadingComponent;

// import React from "react";
// import Backdrop from "@material-ui/core/Backdrop";
// import { makeStyles } from "@material-ui/core/styles";
// import CircularProgress from "@material-ui/core/CircularProgress";
// import LocalShippingIcon from "@material-ui/icons/LocalShipping";
// import { Typography } from "@material-ui/core";

// const useStyles = makeStyles((theme) => ({
//   backdrop: {
//     zIndex: 1301,
//     color: "#fff",
//     // background: "linear-gradient(135deg, rgba(11, 65, 109, 0.95) 0%, rgba(16, 64, 104, 0.95) 100%)",
//     backdropFilter: "blur(8px)",
//   },
//   loaderComp: {
//     display: "flex",
//     alignItems: "center",
//     flexDirection: "column",
//     justifyContent: "center",
//     gap: theme.spacing(3),
//     position: "relative",
//   },
//   // Main container with glassmorphism
//   glassContainer: {
//     background: "rgba(255, 255, 255, 0.1)",
//     backdropFilter: "blur(20px)",
//     borderRadius: "24px",
//     padding: theme.spacing(4),
//     border: "1px solid rgba(255, 255, 255, 0.2)",
//     boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     gap: theme.spacing(2),
//     minWidth: "280px",
//   },
//   // Animated vehicle icon
//   carIcon: {
//     fontSize: 70,
//     color: "#4CAF50",
//     animation: "$carMove 3s infinite ease-in-out",
//     filter: "drop-shadow(0 0 20px rgba(76, 175, 80, 0.6))",
//     position: "relative",
//     zIndex: 2,
//   },
//   "@keyframes carMove": {
//     "0%": {
//       transform: "translateX(-30px) rotate(-5deg)",
//       opacity: 0.8,
//     },
//     "50%": {
//       transform: "translateX(0px) rotate(0deg)",
//       opacity: 1,
//     },
//     "100%": {
//       transform: "translateX(30px) rotate(5deg)",
//       opacity: 0.8,
//     },
//   },
//   // Circular progress wrapper
//   progressWrapper: {
//     position: "relative",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     marginTop: theme.spacing(1),
//   },
//   circularProgress: {
//     color: "#667eea",
//   },
//   progressText: {
//     position: "absolute",
//     fontSize: "0.9rem",
//     fontWeight: 600,
//     color: "#667eea",
//   },
//   // Loading text
//   text: {
//     fontSize: "1.3rem",
//     fontWeight: 700,
//     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//     letterSpacing: "0.5px",
//     marginTop: theme.spacing(1),
//     textAlign: "center",
//   },
//   subText: {
//     fontSize: "0.9rem",
//     color: "rgba(255, 255, 255, 0.7)",
//     marginTop: theme.spacing(0.5),
//     letterSpacing: "1px",
//     textTransform: "uppercase",
//     fontWeight: 500,
//   },
//   // Animated dots
//   dotContainer: {
//     display: "flex",
//     gap: "8px",
//     justifyContent: "center",
//     marginTop: theme.spacing(1),
//   },
//   dot: {
//     width: "10px",
//     height: "10px",
//     borderRadius: "50%",
//     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     animation: "$bounce 1.4s infinite ease-in-out",
//     "&:nth-child(2)": {
//       animationDelay: "0.2s",
//     },
//     "&:nth-child(3)": {
//       animationDelay: "0.4s",
//     },
//   },
//   "@keyframes bounce": {
//     "0%, 80%, 100%": {
//       transform: "translateY(0)",
//       opacity: 0.8,
//     },
//     "40%": {
//       transform: "translateY(-15px)",
//       opacity: 1,
//     },
//   },
//   // Background animated gradient circles
//   bgCircle1: {
//     position: "absolute",
//     width: "150px",
//     height: "150px",
//     borderRadius: "50%",
//     background: "radial-gradient(circle, rgba(102, 126, 234, 0.3) 0%, transparent 70%)",
//     animation: "$float 6s infinite ease-in-out",
//     top: "-50px",
//     left: "-50px",
//     zIndex: 0,
//   },
//   bgCircle2: {
//     position: "absolute",
//     width: "200px",
//     height: "200px",
//     borderRadius: "50%",
//     background: "radial-gradient(circle, rgba(118, 75, 162, 0.2) 0%, transparent 70%)",
//     animation: "$float 8s infinite ease-in-out reverse",
//     bottom: "-80px",
//     right: "-80px",
//     zIndex: 0,
//   },
//   "@keyframes float": {
//     "0%, 100%": {
//       transform: "translateY(0px)",
//     },
//     "50%": {
//       transform: "translateY(30px)",
//     },
//   },
//   // Shimmer effect
//   shimmer: {
//     position: "absolute",
//     top: "-50%",
//     left: "-50%",
//     width: "200%",
//     height: "200%",
//     background: "linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%)",
//     animation: "$shimmerMove 3s infinite",
//   },
//   "@keyframes shimmerMove": {
//     "0%": {
//       transform: "translate(-50%, -50%) rotate(0deg)",
//     },
//     "100%": {
//       transform: "translate(-50%, -50%) rotate(360deg)",
//     },
//   },
//   // Info text with animation
//   infoText: {
//     fontSize: "0.85rem",
//     color: "rgba(255, 255, 255, 0.6)",
//     marginTop: theme.spacing(1),
//     animation: "$fadeInOut 2s infinite",
//     textAlign: "center",
//   },
//   "@keyframes fadeInOut": {
//     "0%, 100%": {
//       opacity: 0.6,
//     },
//     "50%": {
//       opacity: 1,
//     },
//   },
// }));

// const LoadingComponent = ({ isLoading }) => {
//   const classes = useStyles();

//   return (
//     <Backdrop
//       className={classes.backdrop}
//       open={Boolean(isLoading)}
//       style={{ display: isLoading ? "" : "none" }}
//     >
//       {/* Background animated circles */}
//       {/* <div className={classes.bgCircle1} />
//       <div className={classes.bgCircle2} /> */}

//       <section className={classes.loaderComp}>
//         {/* Glass morphism container */}
//         <div className={classes.glassContainer}>
//           {/* Shimmer overlay effect */}
//           <div className={classes.shimmer} />

//           {/* Animated vehicle icon */}
//           <LocalShippingIcon className={classes.carIcon} />

//           {/* Progress wrapper */}
//           <div className={classes.progressWrapper}>
//             <CircularProgress
//               size={80}
//               className={classes.circularProgress}
//               thickness={2.5}
//             />
//             <span className={classes.progressText}>...</span>
//           </div>

//           {/* Main loading text */}
//           <Typography className={classes.text}>
//             Loading Data
//           </Typography>

//           {/* Sub text */}
//           <Typography className={classes.subText}>
//             Please wait
//           </Typography>

//           {/* Animated bouncing dots */}
//           <div className={classes.dotContainer}>
//             <div className={classes.dot} />
//             <div className={classes.dot} />
//             <div className={classes.dot} />
//           </div>

//           {/* Info text with fade animation */}
//           <Typography className={classes.infoText}>
//             Fetching vehicle tracking information...
//           </Typography>
//         </div>
//       </section>
//     </Backdrop>
//   );
// };

// export default LoadingComponent;
